const flag = function flag() {
  const el = document.querySelector('.mitmachen-flag');
  const footer = document.querySelector('.page.footer');

  window.userCanTouch = true;

  window.addEventListener('throttledScroll', () => {
    const topThreshold = window.scrollY > 300;
    const bottomThreshold = (window.scrollY + window.innerHeight) > footer.offsetTop;

    if (bottomThreshold) el.classList.remove('show');
    else if (topThreshold)  el.classList.add('show');
    else el.classList.remove('show');
  });

  window.addEventListener('isTouchDetected', function touchDetect() {
    let firstClicked = false;

    const link = document.querySelector('.mitmachen-flag a');

    link.addEventListener('click', (e) => {
      if (!firstClicked) {
        e.stopPropagation();
        e.preventDefault();
        el.classList.add('expand');

        firstClicked = true;
      } else {
        e.stopPropagation();

      }
    });

    window.addEventListener('click', () => {
      firstClicked = false;
      el.classList.remove('expand');
    });

    window.removeEventListener('isTouchDetected', touchDetect);
  });
};


module.exports = flag;
